import { Section } from "../../types/section";
import clsx from "clsx";

export type ExamSectionListProps = {
    sections: Section[];
    currentSectionId: number;
    setCurrentSectionId: (sectionId: number) => void;
};

export function ExamSectionList({
    sections,
    currentSectionId,
    setCurrentSectionId,
}: ExamSectionListProps) {
    return (
        <div className="py-2">
            <div className="text-xs font-medium text-gray-500 mb-2 px-2">
                EXAM SECTIONS
            </div>
            <div className="space-y-1">
                {sections.map((section) => (
                    <button
                        key={section.sectionName}
                        className={clsx(
                            "w-full text-left px-3 py-2 text-sm rounded-md transition-colors",
                            currentSectionId === section.sectionID
                                ? "bg-primary/10 text-primary font-medium"
                                : "hover:bg-gray-100 text-gray-700",
                        )}
                        onClick={() => setCurrentSectionId(section.sectionID)}
                    >
                        <div className="flex items-center justify-between">
                            {section.sectionName}
                            <div
                                className={clsx("w-2 h-2 rounded-full", {
                                    "bg-green-500":
                                        section.result === "Qualified",
                                    "bg-yellow-500":
                                        section.result ===
                                        "Qualified with additional training",
                                    "bg-red-500":
                                        section.result === "Not Qualified",
                                    "bg-gray-300": !section.result,
                                })}
                            />
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
}
